import { message } from 'antd';
import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects';
import { FETCH_BODY_PARTS, FETCH_BODY_PARTS_ERROR, FETCH_BODY_PARTS_START, FETCH_BODY_PARTS_SUCCESS } from "../../actions/common/bodyPartsAction"
import { fetchBodyPartsRequestAPI } from "../../../services/bodyParts-service";

function* fetchBodyParts() {
    try {

        yield put({ type: FETCH_BODY_PARTS_START })
        const response = yield call(fetchBodyPartsRequestAPI);

        if (response.success) {
            yield put({ type: FETCH_BODY_PARTS_SUCCESS, bodyParts: [...response.data] })

        } else {
            message.error('Failed to fetch body parts!');
            yield put({ type: FETCH_BODY_PARTS_ERROR, error: response.error })
        }

    } catch (error) {
        message.error('Failed to fetch body parts!');
        yield put({ type: FETCH_BODY_PARTS_ERROR, error })
    }
}

function* fetchBodyPartsWatcher() {
    yield takeLatest(FETCH_BODY_PARTS, fetchBodyParts)

}

export default function* rootSaga() {
    yield all([fetchBodyPartsWatcher(),])
}